import { useState, useEffect } from 'react';

/**
 * Hook per debounce di un valore.
 * Restituisce il valore debounced e un flag che indica se il debounce è in corso.
 *
 * @param {*} value - Il valore da debounce
 * @param {number} delay - Ritardo in ms (default 300)
 * @returns {{ debouncedValue: *, isDebouncing: boolean }}
 */
const useDebounce = (value, delay = 300) => {
  const [debouncedValue, setDebouncedValue] = useState(value);
  const [isDebouncing, setIsDebouncing] = useState(false);

  useEffect(() => {
    setIsDebouncing(true);
    const timer = setTimeout(() => {
      setDebouncedValue(value);
      setIsDebouncing(false);
    }, delay);

    return () => clearTimeout(timer);
  }, [value, delay]);

  return { debouncedValue, isDebouncing };
};

export default useDebounce;
